import { render, staticRenderFns } from "./header.vue?vue&type=template&id=70cc0cd8&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"
import style0 from "./header.vue?vue&type=style&index=0&id=70cc0cd8&prod&scoped=true&lang=css"
import style1 from "./header.vue?vue&type=style&index=1&id=70cc0cd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc0cd8",
  null
  
)

export default component.exports